import React from 'react';
import classnames from 'classnames';
import Background from 'images/coupon-back.inline.svg';
import Side from 'images/coupon-side.inline.svg';
import MobileBackground from 'images/coupon-back-mobile.inline.svg';
import MobileSide from 'images/coupon-side-mobile.inline.svg';
import HintLabel from 'components/atoms/HintLabel';
import RemindText from 'components/atoms/RemindText';
import useMedia from 'util/hook/useMedia';

import styles from './index.module.css';

/*
優惠券排序：紫>粉>綠，依照外層來決定對應顏色，
三張優惠券爲一組：
index % 3 = 0 -> 紫
index % 3 = 1 -> 粉
index % 3 = 2 -> 綠
*/
export type ColorStyle = 'purple' | 'pink' | 'green';

interface CouponBodyProperty {
	hashtag: string;
	colorStyle: ColorStyle;
	className?: string;
}

const CouponBody: React.FC<CouponBodyProperty> = ({ hashtag, colorStyle, className }) => {
	const media = useMedia();
	return (
		<div className={classnames(styles.couponBody, className)}>
			{hashtag && (
				<HintLabel
					name={hashtag}
					className={classnames(styles.hintLabel, styles[colorStyle])}
				/>
			)}
			<div className={styles.background}>
				{media === 'mobile' ? <MobileBackground /> : <Background />}
			</div>
			<div className={classnames(styles.side, styles[colorStyle])}>
				{media === 'mobile' ? <MobileSide /> : <Side />}
				<p className={styles[colorStyle]}>COUPON</p>
			</div>
		</div>
	);
};

interface CouponProperty {
	hashtag: string;
	title: string;
	subtitle: string;
	briefDescription: string;
	colorStyle: ColorStyle;
	className?: string;
	onClick?: () => void;
}

const Coupon: React.FC<CouponProperty> = ({
	hashtag,
	title,
	subtitle,
	briefDescription,
	colorStyle,
	className,
	onClick = () => {},
}) => (
	<div
		tabIndex={0}
		role="button"
		className={classnames(styles.coupon, className)}
		onKeyDown={() => {}}
		onClick={onClick}
	>
		<CouponBody hashtag={hashtag} colorStyle={colorStyle} />
		<div className={styles.infos}>
			<h2>{title}</h2>
			<h1>{subtitle}</h1>
			{briefDescription && <RemindText text={briefDescription} className={styles.remind} />}
		</div>
	</div>
);

export default Coupon;
